import { render, staticRenderFns } from "./ProductCustomersAndSuppliers.vue?vue&type=template&id=7f0749ea&scoped=true&lang=pug&"
import script from "./ProductCustomersAndSuppliers.vue?vue&type=script&lang=ts&"
export * from "./ProductCustomersAndSuppliers.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCustomersAndSuppliers.vue?vue&type=style&index=0&id=7f0749ea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0749ea",
  null
  
)

export default component.exports